import { IconComponent } from '@backstage/core-plugin-api';
import { LucideIcon } from 'lucide-react';

/**
 * Creates a Backstage-compatible IconComponent from a Lucide icon
 *
 * This wrapper ensures that Lucide icons (which use the `size` prop) are compatible
 * with Backstage's IconComponent interface (which expects the `fontSize` prop).
 *
 * @param LucideIconComponent - The Lucide icon component to wrap
 * @returns A Backstage-compatible IconComponent
 */
export const createIconComponent = (
  LucideIconComponent: LucideIcon,
): IconComponent => {
  const WrappedIcon: IconComponent = ({ fontSize = 'medium' }) => {
    // Map Backstage fontSize values to Lucide size values (in pixels)
    const sizeMap: Record<string, number | undefined> = {
      small: 18,
      medium: 24,
      large: 32,
      inherit: undefined, // Let Lucide use its default size
    };

    return <LucideIconComponent size={sizeMap[fontSize]} />;
  };

  // Set display name for better debugging
  WrappedIcon.displayName = `Wrapped(${
    LucideIconComponent.displayName || LucideIconComponent.name || 'LucideIcon'
  })`;

  return WrappedIcon;
};
